/**
 * ReadingFooter Component
 * Displays disclaimer and version information
 */

import React from 'react';
import PropTypes from 'prop-types';
import { AlertTriangle, Info } from 'lucide-react';

const ReadingFooter = ({ metrics, lang = 'tr' }) => {
  return (
    <div className="palm-reading-footer" data-testid="palm-reading-footer">
      <div className="disclaimer-section">
        <AlertTriangle size={16} />
        <p>
          {lang === 'tr'
            ? 'Bu yorum sembolik ve eğlence amaçlıdır. Profesyonel tavsiye yerine geçmez.'
            : 'This interpretation is symbolic and for entertainment purposes. It does not replace professional advice.'
          }
        </p>
      </div>
      
      {metrics && (
        <div className="version-info">
          <Info size={14} />
          <span>
            {metrics.model || 'gpt-4o'} | 
            Prompt: {metrics.prompt_version || 'v1.1.0'} | 
            DNA: {metrics.dna_version || 'v1.0.0'} | 
            Engine: {metrics.engine_version || 'v2.5.0'}
          </span>
        </div>
      )}
    </div>
  );
};

ReadingFooter.propTypes = {
  metrics: PropTypes.shape({
    model: PropTypes.string,
    prompt_version: PropTypes.string,
    dna_version: PropTypes.string,
    engine_version: PropTypes.string
  }),
  lang: PropTypes.string
};

export default ReadingFooter;
